<template>
  <div id="app">
    <!--<app-header></app-header>-->

    <section class="first-step">
      <div class="container">
        <h2>Berechnen Sie Ihren<br>gewünschten Liquiditätsbedarf</h2>
        <div class="row justify-content-between">
          <div class="col-md-5">
            <app-konto class="box"></app-konto>
            <app-kredit class="box"></app-kredit>
            <button class="btn btn-primary" @click="updatePiechart">Berechnen</button>
          </div>
          <div class="col-md-6">
            <app-chart class="box"></app-chart>
          </div>       
        </div>
      </div>
    </section>

    <section class="second-step">
      <app-graph v-if="graph"></app-graph>
    </section>

    <!--<app-footer></app-footer>-->
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { EventBus} from './events/updatechart'

//import Header from './components/Header'
//import Footer from './components/Footer'
import Kredit from './components/Kredit';
import Konto from './components/Kontokorrent'
import Chart from './components/PieChart'
import Graph from './components/Graph'

export default {
  data: function () {
    return {
      graph: false
    }
  },
  components: {
    //'app-header': Header,
    'app-kredit': Kredit,
    'app-konto': Konto,
    'app-chart': Chart,
    'app-graph': Graph,
    //'app-footer': Footer
  },
  methods: {
    updatePiechart () {
      if (this.getSollzins === 0 || this.getLiqProv === 0) {
        alert ('Bitte füllen Sie alle Felder aus')
      } else {
        EventBus.$emit('updatechart');
        this.graph = true
      }
    }
  },
  computed: {
    ...mapGetters([
      'getCredit',
      'getKonto',
      'getSollzins',
      'getLiqProv',
      'getSollzinsAmount',
      'getLiqProvAmount'
    ])
  }
}
</script>

<style>
:root {
  --color-primary: 'red'
}

#app {
  font-family: 'SparkasseWeb', Helvetica, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}
body {
  background: #F1F1F1
}

h2 {
  color: red;
  font-size: 1.2rem;
  font-weight: 600
}

a:hover {
  text-decoration: none;
}

.first-step {
  padding-bottom: 60px;
  border-bottom: 4px solid #e3e3e3;
}

.box {
  background: #fff;
  border-radius: 3px;
  padding: 25px;
  margin-bottom: 40px
}

.btn-primary {
  background-color: red;
  border: none;
}

.btn-primary:hover, .btn-primary:active, .btn-primary:focus{
  background-color: red;
  box-shadow: none;
}

.btn-primary:not(:disabled):not(.disabled).active, .btn-primary:not(:disabled):not(.disabled):active, .show>.btn-primary.dropdown-toggle {
    color: #fff;
    background-color: #bc0000;
    border-color: #bc0000;
}

.btn-primary:not(:disabled):not(.disabled).active:focus, .btn-primary:not(:disabled):not(.disabled):active:focus, .show>.btn-primary.dropdown-toggle:focus {
  box-shadow: none;
}

.legend__label--one, .leged__label--two, .legend__label--t {
  content: '';
  display: inline-block;
  margin-right: 2px;
  height: 20px; 
  width: 20px;
  background: red
}

.second-step {
  margin: 60px 0;
}
</style>
